jQuery(document).ready(function ($) {

  let menuOpen = false;


  // Add slideDown animation to Bootstrap dropdown when expanding.

  $('.dropdown').on('show.bs.dropdown', function () {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown("fast", "linear");
    //$(this).find('.dropdown-menu').first().stop(true, true).slideToggle();
  });

  // Add slideUp animation to Bootstrap dropdown when collapsing.
  $('.dropdown').on('hide.bs.dropdown', function () {
    //$(this).find('.dropdown-menu').first().stop(true, true).slideToggle();

    $(this).find('.dropdown-menu').first().stop(true, true).slideUp("fast", "linear");
  });


  $(window).scroll(function (event) {
    var scrollTop = $(window).scrollTop();
    var scrollHeight = document.body.scrollHeight;
    var articleBottomOffset = $('#completedRead').offset() ? scrollHeight - $('#completedRead').offset().top : 0;
    var articleFixedMenuThreshold = 60;
    var shareButtonFixTreshold = 80;
    var notSingleArticleFixedMenuThreshold = 60;

    // Sticky menu
    if (scrollTop > articleFixedMenuThreshold) {
      $('#nav-sticky').toggleClass('hideMe', false);
      $('#mega-menu').toggleClass('scrollMode', true);
    } else {
      $('#nav-sticky').toggleClass('hideMe', true);
      $('#mega-menu').toggleClass('scrollMode', false);
    }

    /*
    if (scrollTop > shareButtonFixTreshold) {
      $('.ssba-wrap').toggleClass('scrollMode', true);
    } else {
      $('.ssba-wrap').toggleClass('scrollMode', false);
    }
    */



    if (scrollTop > notSingleArticleFixedMenuThreshold) {
      $('.not-single').toggleClass('scrollMode', true);
      $('.content_wrapper').toggleClass('scrollMode', true);
    } else {
      $('.not-single').toggleClass('scrollMode', false);
      $('.content_wrapper').toggleClass('scrollMode', false);
    }

    // Progress bar
    if (!$(".newsner_infinite").length) {
      $('#nav-sticky_progress-bar_fill').width(100 * (scrollTop / (scrollHeight - articleBottomOffset)) + "%");
    };

  });

  $('.mobile-toggle').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    menuOpen = !menuOpen;
    $('.mobile-toggle').attr('aria-expanded', menuOpen);
    $('#mega-menu').toggleClass('hideMe', !menuOpen);
    $('body').toggleClass('blockScroll', menuOpen);
  });

  $(window).click(function (e) {
    if (menuOpen && !$(e.target).is('.mobile-toggle') && !$(e.target).is('#mega-menu') && !$(e.target).parents("#mega-menu").size()) {
      e.preventDefault();
      e.stopPropagation();
      menuOpen = !menuOpen;
      $('#mega-menu').toggleClass('hideMe', !menuOpen);
      $('body').toggleClass('blockScroll', menuOpen);
    }
  });

  //searchbar toggle
  $("button.search-icon.icon").click(function () {
    $(".quick-search").toggleClass("active");
  });

});